import React, { useState } from 'react';
import Localize from 'react-intl-universal';

import styled from 'styled-components';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import DatePicker from '@components/DatePicker';
import style from '@components/Filters/style/Filters.module.scss';

const CalendarContainer = styled(Box)(() => ({
  display: 'flex',
  marginBottom: '1rem',
  '& .MuiInputBase-root': {
    cursor: 'pointer'
  }
}));

const CalendarRangeFilter = ({
  title,
  valueFrom,
  valueTo,
  handleDateChange,
  disabledFrom,
  disabledTo,
  name
}) => {
  const [openAccordion, setOpenAccordion] = useState(true);

  const onAccordionClick = () => {
    setOpenAccordion((prevState) => !prevState);
  };

  const onChange = (date, range) => {
    handleDateChange({ target: { type: 'calendar-range' } }, { date, range });
  };

  const shouldDisableFrom = (date) => {
    return disabledFrom && date < disabledFrom;
  };
  const shouldDisableTo = (date) => {
    return disabledTo && date > disabledTo;
  };

  return (
    <Box className={style.filterRow}>
      <Accordion
        expanded={openAccordion}
        onChange={onAccordionClick}
        data-testid={`accordionFilterGroup-${name}`}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls={`panel-${name}-content`}
          id={`panel-${name}-header`}
        >
          <Typography sx={{ fontWeight: 'bold' }}>{title}</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <CalendarContainer data-testid={`calendarContainerFrom-${name}`}>
            <DatePicker
              label={Localize.get('App.rangeFromDate')}
              onChange={(date) => onChange(date, 'from')}
              value={valueFrom}
              shouldDisableDate={shouldDisableFrom}
            />
          </CalendarContainer>
          <CalendarContainer data-testid={`calendarContainerTo-${name}`}>
            <DatePicker
              label={Localize.get('App.rangeToDate')}
              onChange={(date) => onChange(date, 'to')}
              value={valueTo}
              shouldDisableDate={shouldDisableTo}
            />
          </CalendarContainer>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

export default CalendarRangeFilter;
